import { Vue, Component } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

type CustomMessage = {
  [key: string]: string;
  [key: number]: string;
}

@Component
export default class ApiErrorMixin extends Vue {
  // eslint-disable-next-line class-methods-use-this
  apiErrorMapper(code: number, customMessage?: CustomMessage): string {
    let message = '';

    if (customMessage) {
      if (customMessage[code]) {
        message = customMessage[code];
        return message;
      }
    }

    switch (code) {
      case 3:
        message = '權限錯誤：\n使用者權限不符合，包含不合法登入者與權限不符';
        break;
      case 4:
        message = '參數錯誤：\n所有使用者傳入的參數錯誤';
        break;
      case 5:
        message = '內部錯誤：\n所有未被歸納的錯誤';
        break;
      case 101:
        message = '該筆資料不存在';
        break;
      case 102:
        message = '帳號或密碼錯誤';
        break;
      case 103:
        message = '資料重複';
        break;
      case 441:
        message = '檔案格式錯誤';
        break;
      case 442:
        message = '檔案尺寸錯誤';
        break;
      case 443:
        message = '檔案大小超過限制';
        break;

      default:
        message = '未知錯誤';
        break;
    }

    return message;
  }

  // eslint-disable-next-line class-methods-use-this
  apiHttpErrorMapper(code: number, customMessage?: CustomMessage) {
    let message = '';

    if (customMessage) {
      if (customMessage[code]) {
        message = customMessage[code];
        return message;
      }
    }

    switch (code) {
      case 401:
        message = '權限錯誤';
        break;
      case 403:
        message = '權限錯誤';
        break;
      case 404:
        message = 'API 路徑錯誤';
        break;
      case 500:
        message = '伺服器內部錯誤';
        break;

      default:
        message = '未知錯誤';
        break;
    }

    return message;
  }

  apiErrorCodeAlert(code: number, title?: string, customMessage?: CustomMessage) {
    let message = '';
    if (customMessage) {
      if (customMessage[code]) {
        message = customMessage[code];
      } else {
        message = this.apiErrorMapper(code);
      }
    } else {
      message = this.apiErrorMapper(code);
    }

    this.$notify.show('error filled', message, title, { duration: 3000, permanent: false });
  }

  apiHttpErrorAlert(error: AxiosResponse, title?: string, customMessage?: CustomMessage) {
    console.log(typeof error);
    let message = '';

    if (error.status) {
      if (customMessage && customMessage[error.status]) {
        message = customMessage[error.status];
      } else {
        message = this.apiHttpErrorMapper(error.status);
      }
    }

    this.$notify.show('error filled', message, title, { duration: 3000, permanent: false });
  }
}
